import { put, takeLatest, call } from 'redux-saga/effects';
import { fetchFacilitiesSuccess } from '../actions';
import ActionTypes from '../constants';
import { coreAPI } from 'utils/request';
import { showErrorNotification } from '@aha/utils';

export function* doFetchFacilities() {
  try {
    const { data } = yield call(coreAPI.get, '/v1/pms/facilities');

    yield put(fetchFacilitiesSuccess(data));
  } catch (err) {
    showErrorNotification('Fail to fetch', err);
  }
}

export default function* watchFetchCities() {
  yield takeLatest(ActionTypes.FETCH_FACILITIES, doFetchFacilities);
}
